import styled from 'styled-components';
import { Tabs, Select } from 'antd';

export const ResourcesSectionContainer = styled.div`
  max-width: 1219px;
  padding: 10px 28px;
  margin: 0 auto;

  .resources-section--title {
    margin-bottom: 25px;

    h2 {
      font-family: 'Sofia Pro';
      font-weight: bold;
      font-size: 25px;
      line-height: 120%;
      letter-spacing: -0.01em;
      color: var(--white-color);
    }

    .resources-section--arrow-container {
      display: none;

      .resources-section--arrow {
        width: 35px;
        height: 35px;
        border: 1px solid var(--white-color);
        border-radius: 50%;
        margin-right: 15px;
        cursor: pointer;

        svg {
          width: 100%;
          height: 100%;
          padding: 10px;

          path {
            stroke: white;
          } 
        }

        &.left-arrow {
          svg {
            transform: scaleX(-1);
            padding-right: 8px;
          }
        }

        &.right-arrow {
          svg {
            padding-left: 12px;
          }
        }

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  .resources-section--content {
    margin-bottom: 50px;

    .resources-section--tab-content {
      padding: 34px 0;

      .resources-section--tab-header {
        display: flex;
        align-items: center;
        margin-bottom: 40px;

        .resources-section--tab-header-select {
          display: flex;
        }

        .link-view-all {
          font-family: 'Sofia Pro';
          font-weight: 500;
          color: var(--white-color);
          line-height: 150%;
          font-size: 20px;
          margin-left: 20px;

          &:hover {
            opacity: 0.5;
          }
        }
      }

      .resources-section--tab-body {

      }
    }
  }

  @media (max-width: 576px) {
    padding-left: 20px;
    padding-right: 20px;

    .resources-section--title {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .resources-section--arrow-container {
        display: flex;
      }
    }

    .resources-section--content {
      .resources-section--tab-content {
        padding: 25px 0;

        .resources-section--tab-header {
          margin-bottom: 20px;

          .resources-section--tab-header-select {
            flex: 1;
            flex-direction: column;
          }

          .link-view-all {
            font-size: 18px;
            margin: 0;
            white-space: nowrap;
          }
        }
      }
    }
  }
`;

export const ResourcesTabs = styled(Tabs)`
  .ant-tabs-nav {
    &::before {
      border-bottom: none !important;
    }

    .ant-tabs-tab {
      font-family: Sofia Pro;
      font-style: normal;
      font-weight: 900;
      font-size: 49px;
      line-height: 110%;
      letter-spacing: -0.04em;
      color: var(--white-color);
      opacity: 0.2;
      margin-right: 100px;

      &.ant-tabs-tab-active {
        opacity: 1;

        .ant-tabs-tab-btn {
          color: var(--white-color);
          font-weight: 900;
        }
      }
    }

    .ant-tabs-ink-bar {
      height: 4px !important;
      background: var(--blue-primary) !important;
      width: 166px !important;
    }

    .ant-tabs-nav-more {
      background: var(--white-color) !important;
    }

    @media (max-width: 768px) {
      .ant-tabs-tab {
        font-size: 32px;
        margin-right: 20px;
        padding-right: 30px;
      }

      .ant-tabs-ink-bar {
        height: 3px !important;
        width: 100px !important;
      }
    }
  }
`;

export const FilterSelect = styled(Select)`
  min-width: 245px;
  margin-right: 20px !important;

  .ant-select-selector {
    height: 56px !important;
    background: transparent !important;
    padding: 0 23px !important;
  }

  .ant-select-arrow {
    color: var(--white-color);
  }

  .ant-select-selection-item {
    font-family: Sofia Pro;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 23px !important;
    color: var(--white-color);
    padding: 17px 0 !important;
  }

  @media (max-width: 768px) {
    min-width: 200px;

    .ant-select-selection-item {
      font-size: 18px;
    }
  }

  @media (max-width: 576px) {
    margin-bottom: 20px !important;

    &:last-child {
      margin-bottom: 0 !important;
    }

    .ant-select-selector {
      padding: 0 18px !important;
    }

    .ant-select-arrow {
      right: 20px;
    }

    .ant-select-selection-item {
      font-size: 18px;
    }
  }
`;
